import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";
import { getDeclination } from "Utils/text";

const style = theme => ({
    root: {
        marginBottom: "27px",
    },
    inputCheckbox: {
        display: "none",
    },
    checkWrapper: {
        display: "flex",
        alignItems: "center",
    },
    checkbox: {
        width: "28px",
        height: "30px",
        display: "inline-block",
        padding: "3px",
        border: "1px solid " + theme.palette.colors.oneMoreGrey,
        borderRadius: "5px",
    },
    icon: {
        fontSize: "20px",
        color: theme.palette.colors.purplishBlue,
    },
    outCheck: {
        opacity: 0,
    },
    textWrapper: {
        fontSize: "16px",
        fontFamily: theme.fonts.medium,
        color: theme.palette.colors.darkSlateBlue,
        lineHeight: "1.5",
        letterSpacing: "1px",
        marginLeft: "10px",
    },
    value: {
        color: theme.palette.colors.purplishBlue,
    },
    price: {
        fontWeight: "bold",
    },
    infinite: {
        position: "relative",
        top: "3px",
    },
});

const InputCheckbox = withStyles(style)(
    ({ classes, info, convergent, onChangeInput, text }) => {
        const changeInput = () => {
            onChangeInput && onChangeInput();
        };
        if (convergent.mobile_new == undefined) {
            return null;
        }
        let convergentMobile = convergent.mobile_new;
        let convergentInternet = +convergentMobile.internet;
        let convergentCalls = +convergentMobile.calls;
        let convergentSms = +convergentMobile.sms;

        // Если был интернет и есть еще инфа о мобиле
        let oneSymbol =
            (!!convergentInternet || convergentMobile.internet_type === 1) &&
            (!!convergentCalls ||
                convergentMobile.calls_type === 1 ||
                !!convergentSms ||
                convergentMobile.sms_type === 1);

        // Если была связь и есть ещё смс
        let secondSymbol =
            (!!convergentCalls || convergentMobile.calls_type === 1) &&
            (!!convergentSms || convergentMobile.sms_type === 1);

        return (
            <div className={classes.root} datatest={info.datatest}>
                <input
                    id={"convergent"}
                    type="checkbox"
                    checked={info.check}
                    onChange={() => changeInput()}
                    className={classes.inputCheckbox}
                />
                <label className={classes.checkWrapper} htmlFor={"convergent"}>
                    <div className={classes.checkbox}>
                        <div
                            className={classNames(
                                "icon24 icon-check",
                                classes.icon,
                                {
                                    [classes.outCheck]: !info.check,
                                }
                            )}
                        />
                    </div>
                    <div className={classes.textWrapper}>
                        <span>{text.i_want_internet_convergent}</span>

                        {!!convergentInternet && (
                            <span className={classes.value}>
                                {convergentInternet} {text.GB}
                            </span>
                        )}
                        {convergentMobile.internet_type === 1 && (
                            <span className={classes.value}>
                                <span
                                    className={classNames(
                                        "icon24 icon-infinite",
                                        classes.infinite
                                    )}
                                />{" "}
                                {text.GB}
                            </span>
                        )}
                        {oneSymbol && <span>, </span>}

                        {!!convergentCalls && (
                            <span className={classes.value}>
                                {convergentCalls} {text.min}
                            </span>
                        )}
                        {convergentMobile.calls_type === 1 && (
                            <span className={classes.value}>
                                <span
                                    className={classNames(
                                        "icon24 icon-infinite",
                                        classes.infinite
                                    )}
                                />{" "}
                                {text.min}
                            </span>
                        )}
                        {secondSymbol && <span>, </span>}

                        {!!convergentSms && (
                            <span className={classes.value}>
                                {convergentSms} {text.sms_2}
                            </span>
                        )}
                        {convergentMobile.sms_type === 1 && (
                            <span className={classes.value}>
                                <span
                                    className={classNames(
                                        "icon24 icon-infinite",
                                        classes.infinite
                                    )}
                                />{" "}
                                {text.sms_2}
                            </span>
                        )}

                        {!!convergent.tv && (
                            <span>
                                {text.i_want_tv_convergent}{" "}
                                <span className={classes.value}>
                                    {convergent.tv.channels}{" "}
                                    {getDeclination(
                                        convergent.tv.channels,
                                        text.SERVICES_CHANNEL_SUFFIX.ONE,
                                        text.SERVICES_CHANNEL_SUFFIX.TWO,
                                        text.SERVICES_CHANNEL_SUFFIX.FIVE
                                    )}
                                </span>
                            </span>
                        )}

                        {convergent.cost < 0 && (
                            <span>
                                {text.i_want_convergent_1}
                                <span className={classes.price}>
                                    {Math.abs(convergent.cost)}
                                </span>
                                {getDeclination(
                                    Math.abs(convergent.cost),
                                    text.rubles_1,
                                    text.rubles_2,
                                    text.rubles_3
                                )}
                            </span>
                        )}
                        {convergent.cost == 0 && (
                            <span className={classes.price}>{text.unpaid}</span>
                        )}
                        {convergent.cost > 0 && (
                            <span>
                                {text.i_want_convergent_2}
                                <span className={classes.price}>
                                    {convergent.cost}
                                </span>
                                {getDeclination(
                                    convergent.cost,
                                    text.rubles_1,
                                    text.rubles_2,
                                    text.rubles_3
                                )}
                            </span>
                        )}
                    </div>
                </label>
            </div>
        );
    }
);

export default InputCheckbox;
